import apiClient from '@/services/axios';

export async function get(venueId, year, month) {
  var response = await apiClient.get(`/ActivationPlanBudgets/${venueId}/${year}/${month}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get activation plan budget for', year, month)
}